import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import NavigationLink from "../navigation/navigationLink";
import Tag from "../tag/tag";

import "./articleCard.scss";

const ArticleCard = ({
  button = null,
  category = null,
  className = "",
  date = null,
  excerpt = null,
  headline,
  href,
  image = null,
}) => {
  const maxChars = 9999;

  const inner = (
    <>
      <div className="article-card__image-container">
        <div
          className={classNames(
            "article-card__image",
            {
              "placeholder-image placeholder-image--article": !image,
            },
          )}
        >
          {image}
        </div>
      </div>
      {category && (
        <div className="d-flex article-card__subline">
          <div className="article-card__category">
            <Tag>{category}</Tag>
          </div>
          {date && (
            <div className="article-card__date typo-body1">
              {date}
            </div>
          )}
        </div>
      )}
      <div className="article-card__headline">
        {headline}
      </div>
      <div className="article-card__excerpt">
        {excerpt.length > maxChars
          ? `${excerpt.substring(0, maxChars - 3)}...`
          : excerpt}
      </div>
      {button}
    </>
  );

  const classNameString = classNames(
    "no-style article-card",
    className,
  );

  if (!href) {
    return (
      <div className={classNameString}>
        {inner}
      </div>
    );
  }

  return (
    <NavigationLink href={href} className={classNameString}>
      {inner}
    </NavigationLink>
  );
};

ArticleCard.propTypes = {
  button: PropTypes.oneOfType([PropTypes.object]),
  category: PropTypes.string,
  className: PropTypes.string,
  date: PropTypes.node,
  excerpt: PropTypes.string,
  headline: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.object]),
};

export default ArticleCard;
